module.exports = __webpack_public_path__ + "media/hyper/images/startman-847f04cb1585cf57efb0b7e85ad5b8f8.svg";